var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("h2", { staticClass: "m-n" }, [_vm._v("だれでも掲示板")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "flexbox gap-20" }, [
        _c("div", { staticClass: "flexbox gap-10" }, [
          _c(
            "button",
            {
              ref: "postRequest",
              staticClass: "btn btn-info w-100",
              attrs: { "data-toggle": "modal", "data-target": "#postRequest" },
              on: { click: _vm.openModalRequest }
            },
            [_vm._v("\n        投稿\n      ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-guide w-120 mr-l-5",
              on: { click: _vm.openModalGuideLine }
            },
            [_vm._v("\n        ガイドライン\n      ")]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flexbox gap-10" }, [
          _c("div", { staticClass: "w-400" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.keyword,
                  expression: "keyword"
                }
              ],
              staticClass: "form-control",
              attrs: { type: "text" },
              domProps: { value: _vm.keyword },
              on: {
                keydown: function($event) {
                  if (
                    !("button" in $event) &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  ) {
                    return null
                  }
                  return _vm.onHandleSearch($event)
                },
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.keyword = $event.target.value
                }
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-info w-100",
              on: { click: _vm.onHandleSearch }
            },
            [_vm._v("\n        検索\n      ")]
          )
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "row custom_table" },
        [
          _c("base-table", {
            ref: "requestTable",
            attrs: {
              url: "requests",
              method: "get",
              columns: _vm.$options.requestColumns,
              paginationStorageKey: "requestList",
              searchValue: _vm.searchValue
            },
            on: { clickRow: _vm.openRequestDetail },
            scopedSlots: _vm._u([
              {
                key: "createdAt",
                fn: function(props) {
                  return [_c("span", [_vm._v(_vm._s(props.rowData.createdAt))])]
                }
              },
              {
                key: "likesCount",
                fn: function(props) {
                  return [
                    _c("span", { staticClass: "like-count" }, [
                      _vm._v(_vm._s(_vm.formatAmount(props.rowData.likesCount)))
                    ])
                  ]
                }
              },
              {
                key: "title",
                fn: function(props) {
                  return [
                    _c("span", { staticClass: "title-color" }, [
                      _vm._v(_vm._s(props.rowData.title))
                    ]),
                    _vm._v(" "),
                    props.rowData.commentsCount > 0
                      ? _c("div", { staticClass: "comment" }, [
                          _c("img", {
                            attrs: { src: "/static/dists/img/ic_comment.png" }
                          }),
                          _vm._v(" "),
                          _c("span", { staticClass: "comment_count" }, [
                            _vm._v(
                              _vm._s(
                                _vm.formatAmount(props.rowData.commentsCount)
                              ) + " 件のコメント"
                            )
                          ])
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.isShowRequest
        ? _c("post-request", { on: { close: _vm.closeModalRequest } })
        : _vm._e(),
      _vm._v(" "),
      _vm.openModalGuide
        ? _c("guide-line", { on: { close: _vm.closeModalGuideLine } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row m-t-md" }, [
      _c("div", { staticClass: "hpanel" }, [
        _c("div", { staticClass: "panel-body" }, [
          _c("div", { staticClass: "text-left" }, [
            _vm._v(
              "\n          SaleMonsterのセラーさま同士が自由に意見交換や情報共有を行うためのオンライン掲示板です。\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-left" }, [
            _vm._v(
              "\n          物販関連のことでしたら、SaleMonster以外のトピックでもOK！\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-left" }, [
            _vm._v(
              "\n          コメントをしたり、いいね！することもできます。\n        "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "text-left" }, [
            _vm._v(
              "\n          SaleMonsterに対するリクエストも受け付けております♪\n        "
            )
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b30dc5e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b30dc5e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/request/Request.vue
// module id = null
// module chunks = 